import { CloudWatchWidget } from "./types";

export function widget(title: string, region: string, metrics: (string | object)[][], x = 0, y = 0, width = 24, height = 8, isExtendedPeriod?: boolean): CloudWatchWidget {
  return widgetWithUnit(title, region, metrics, x, y, width, height, isExtendedPeriod)
}

export function widgetWithUnit(title: string, region: string, metrics: (string | object)[][], x = 0, y = 0, width = 24, height = 8, isExtendedPeriod?: boolean, leftUnit?: string, rightUnit?: string): CloudWatchWidget {
  const period = isExtendedPeriod ? 300 : 60;  // Set period to 300 if isExtendedPeriod is true, otherwise 60
  return {
    type: 'metric',
    x: x,
    y: y,
    width: width,
    height: height,
    properties: {
      region: region,
      title: title,
      period: period,
      view: "timeSeries",
      stacked: false,
      metrics: metrics,
      yAxis: {
        left: {
          min: 0,
          label: leftUnit,
          showUnits: !leftUnit
        },
        right: {
          min: 0,
          label: rightUnit,
          showUnits: !rightUnit
        }
      }
    }
  }
}
